import React from 'react';
import PropTypes from 'prop-types';
import CorporatePage from '../../components/CorporatePage';
import content from '../../data/pages/workflows-ia';

const WorkflowsIaPage = ({ pageContext: { locale } }) => (
  <CorporatePage locale={locale} path="/solutions/workflows-ia/" content={content} />
);

WorkflowsIaPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default WorkflowsIaPage;
